import React from 'react';
import { Field, FieldProps } from '../Field';
import { BaseInput, BaseInputProps } from './BaseInput';

export interface InputProps extends FieldProps, Omit<BaseInputProps, 'error'> {}

/**
 * A pre-made form component for text inputs.
 * Allows for additional context to be displayed, such as description, and error.
 *
 * If different styling is required, a custom input can be created using form primitives.
 */
export const Input = React.forwardRef<HTMLInputElement, InputProps>(function (
    { description, error, helperText, label, ...inputProps },
    ref
) {
    const { disabled, id, required } = inputProps;

    return (
        <Field
            description={description}
            disabled={disabled}
            error={error}
            helperText={helperText}
            id={id}
            label={label}
            required={required}
        >
            <BaseInput ref={ref} error={!!error} {...inputProps} />;
        </Field>
    );
});
